import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const ViewLeadSources = Loadable(
  lazy(() =>
    import("./source").then(({ ViewLeadSources }) => ({
      default: ViewLeadSources,
    })),
  ),
);

export const sourceRoutes = [
  {
    path: "/lead-source",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.EVENT_LEADS]}>
        <ViewLeadSources />
      </AuthorizedRoute>
    ),
  },
];

